import { push } from '../services/router-utils';

export default function pushToCreatePost() {
  return dispatch => {
    dispatch(push('/create-post'));
  };
}
